import { useLocalisation } from '@3plearning/lingui-cdn';
import {
    BRONZE,
    DIAMOND,
    EMERALD,
    EPIC,
    GOLD,
    LEGEND,
    PLATINUM,
    SILVER
} from '../../../../../containers/participation/config/certificate-constants';

export const useTranslations = () => {
    const { i18n } = useLocalisation();

    return {
        certificates: i18n.t`CertificatesModal - Certificates`,
        selectVersion: i18n.t`CertificatesModal - SelectVersion`,
        fullColour: i18n.t`CertificatesModal - FullColour`,
        printerFriendly: i18n.t`CertificatesModal - PrinterFriendly`,
        selectRanksAndVersion: i18n.t`CertificatesModal - SelectRankAndVersion`
    };
};

export const useCertificateDownloadTranslations = () => {
    const { i18n } = useLocalisation();

    return {
        [BRONZE.type]: i18n.t`Download - Certificates - Bronze`,
        [SILVER.type]: i18n.t`Download - Certificates - Silver`,
        [GOLD.type]: i18n.t`Download - Certificates - Gold`,
        [PLATINUM.type]: i18n.t`Download - Certificates - Platinum`,
        [EMERALD.type]: i18n.t`Download - Certificates - Emerald`,
        [DIAMOND.type]: i18n.t`Download - Certificates - Diamond`,
        [EPIC.type]: i18n.t`Download - Certificates - Epic`,
        [LEGEND.type]: i18n.t`Download - Certificates - Legend`
    };
};



// WEBPACK FOOTER //
// ./components/certificates/components/certificate-confirmation-modal/hooks/use-translations.js